import cx from "classnames";
import React, { useContext } from "react";
import { ToolbarContext } from "./../../ricos-context";
import styles from "./url-link-button-scss";
const AnchorLinkButton = ({ toolbarItem }) => {
  var _a;
  const { t } = useContext(ToolbarContext);
  const dataHook = (_a = toolbarItem.presentation) == null ? void 0 : _a.dataHook;
  return /* @__PURE__ */ React.createElement("div", { className: styles.toolbarUrlContainer }, /* @__PURE__ */ React.createElement(
    "button",
    {
      "data-hook": dataHook,
      className: cx(styles.toolbarUrl, styles.toolbarUrlAnchor),
      onClick: (e) => {
        e.preventDefault();
        toolbarItem.commands.click();
      },
      type: "button"
    },
    t("LinkTo_Toolbar_GoTo")
  ));
};
export {
  AnchorLinkButton
};
//# sourceMappingURL=anchor-link-button.js.map
